 export enum ModalType {
  // Old
  DEFAULT = 'DEFAULT',
  ASSIGN_BADGES = 'ASSIGN_BADGES',
  CONFIRM = 'CONFIRM',
  DFP = 'DFP',
  EMAIL_CONFIRMATION = 'EMAIL_CONFIRMATION',
  EXISTING_LOGIN_SOCIAL = 'EXISTING_LOGIN_SOCIAL',
  FEEDBACK = 'FEEDBACK',
  HULOCAL_SIGN_UP = 'HULOCAL_SIGN_UP',
  LOGIN = 'LOGIN',
  PRIVACY_TIPS = 'PRIVACY_TIPS',
  SEARCH_FILTER_OPTIONS = 'SEARCH_FILTER_OPTIONS',
  SEARCH_SORT_BY = 'SEARCH_SORT_BY',
  SENTIMENT_FEEDBACK = 'SENTIMENT_FEEDBACK',
  SIGN_UP = 'SIGN_UP',
  SIGN_UP_SOCIAL = 'SIGN_UP_SOCIAL',
  SIGN_UP_SURVEY = 'SIGN_UP_SURVEY',
  SIMILAR_TO_ME_TIPS = 'SIMILAR_TO_ME_TIPS',
  TAG_FILTER_OPTIONS = 'TAG_FILTER_OPTIONS',
  // New
  COMMUNITY_GUIDELINES = 'COMMUNITY_GUIDELINES',
  COMMUNITY_INVITES = 'COMMUNITY_INVITES',
  COMMUNITY_TOP_CONDITIONS = 'COMMUNITY_TOP_CONDITIONS',
  CONTACT_ADMINS = 'CONTACT_ADMINS',
  DELETE_POST = 'DELETE_POST',
  EDIT_BADGES = 'EDIT_BADGES',
  EMAIL_SUBSCRIBE_ALL_POSTS = 'EMAIL_SUBSCRIBE_ALL_POSTS',
  EMAIL_UNSUBSCRIBE_ALL_EMAILS = 'EMAIL_UNSUBSCRIBE_ALL_EMAILS',
  PROGRAM_ENROLL = 'PROGRAM_ENROLL',
  GUIDELINES_ADD = 'GUIDELINES_ADD',
  GUIDELINES_DELETE = 'GUIDELINES_DELETE',
  GUIDELINES_INFO = 'GUIDELINES_INFO',
  IFRAME = 'IFRAME',
  LOST_ACCESS_CODE = 'LOST_ACCESS_CODE',
  MARKETING_OPT_IN = 'MARKETING_OPT_IN',
  NEEDS_ASSESSMENT_TIPS = 'NEEDS_ASSESSMENT_TIPS',
  NEEDS_ASSESSMENT = 'NEEDS_ASSESSMENT',
  NHS_TAG_CONTENT = 'NHS_TAG_CONTENT',
  PRIVACY_REMINDER = 'PRIVACY_REMINDER',
  PROFILE_SURVEY = 'PROFILE_SURVEY',
  PROGRAM_COMPLETED = 'PROGRAM_COMPLETED',
  REMOVE_MEMBER_FROM_COMMUNITY = 'REMOVE_MEMBER_FROM_COMMUNITY',
  REPLY_IMAGE_DESCRIPTION = 'REPLY_IMAGE_DESCRIPTION',
  REPORT = 'REPORT',
  SAVE_POST = 'SAVE_POST',
  TAKE_PROFILE_SURVEY_ON_SIGNUP = 'TAKE_PROFILE_SURVEY_ON_SIGNUP',
  TAKE_PROFILE_SURVEY = 'TAKE_PROFILE_SURVEY',
}
export default ModalType;
